import { createRoutine } from 'redux-saga-routines';

const SUBMIT_CHECKOUT_PAYMENT_ACTION_PREFIX = 'SUBMIT_CHECKOUT_PAYMENT_ACTION';

export const submitCheckoutPaymentAction = createRoutine(SUBMIT_CHECKOUT_PAYMENT_ACTION_PREFIX);
